import { Box, Switch } from '@mui/material'
import { Card } from 'components/Form/Styled'
import styled from 'styled-components'
import { CustomSection, WrapImg } from 'styles/GlobalStyle'
import { bg, black } from 'styles/theme'
import { styled as muiStyled } from '@mui/material/styles';
import { thirdly } from 'styles/theme'
import { Center, CenterStyle } from 'styles/GlobalCss'
import { thirdly3 } from 'styles/theme'
import { thirdly2 } from 'styles/theme'
import { borderRadius, boxSizing, display, fontSize, fontWeight, height } from '@mui/system'
import { useMemo } from 'react'
import { useMediaQuery } from '@mui/material';
import { keyBy } from 'lodash'
import { dark } from 'styles/theme'

const radius = 25

const bpValues = {
    xs: 0,
    sm: 600,
    md: 960,
    lg: 1280,
    xl: 1480,
    xxl: 1780,
    xxxl: 2000,
    xxxxl: 2200
}
const { xs, sm, md, lg, xl, xxl, xxxl, xxxxl } = bpValues

const breakpoints = [
    { name: 'xxxxl', value: `@media (min-width:${xxxxl}px)`, upSize: xxxxl / xxxl },
    { name: 'xxxl', value: `@media (min-width:${xxxl}px)`, upSize: xxxl / xxl },
    { name: 'xxl', value: `@media (min-width:${xxl}px)`, upSize: xxl / xl },
    { name: 'xl', value: `@media (min-width:${xl}px)`, upSize: xl / lg },
    { name: 'lg', value: `@media (min-width:${lg}px)`, upSize: lg / md },
    { name: 'md', value: `@media (min-width:${md}px)`, upSize: md },
    { name: 'sm', value: `@media (min-width:${sm}px)`, upSize: sm },
];

const CardStyles = muiStyled(Box)(({ button, disabled, alignCenter, color, bg, height, theme, $systemUI, cartoonHeight, cartoonWidth }) => {
    let cardW = 280

    return {
        border: `1px solid ${thirdly3}`,
        borderRadius: radius,
        cursor: !disabled && button && 'pointer',
        alignItems: alignCenter && "center",
        pointerEvents: disabled && "none",
        backgroundColor: bg || "white",
        width: cardW,
        display: "flex",
        flexDirection: "column",
        justifyContent: alignCenter ? "center" : "space-between",
        padding: 25,
        boxSizing: "border-box",
        height: height || "100%",
        fontSize: 30,
        fontWeight: 700,
        color: color || dark,
    }
});

const GeneralDashboardStyles = muiStyled(Box)(({ theme, $systemUI }) => {
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

    // const mediaQueries = breakpoints.map(bp => useMediaQuery(bp.value));
    // const bpIndex = mediaQueries.findIndex(media => media);
    // const breakpoint = breakpoints[bpIndex].upSize

    // let cardW = 245
    // let cardGap = 20
    // let cardHeaderH = 350
    // if (bpIndex != -1) {
    //     cardW = breakpoint * cardW
    //     cardGap = breakpoint * cardGap
    //     cardHeaderH = breakpoint * cardHeaderH
    // }
    let cardW = 280
    let cardGap = 20
    let cardHeaderH = 400
    let cartoonHeight = 240
    let cartoonWidth = 160

    let s_cardHeaderH = 150
    let s_cardW = "100%"
    let s_cartoonHeight = 170
    let s_cartoonWidth = 90
    let s_cardGap = 8

    return {
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        height: "100%",
        alignItems: "center",
        [theme.breakpoints.down('md')]: {
            alignItems: "start"
        },
        '.dashboard': {
            overflow: "auto",
            boxSizing: "border-box",
            padding: 15,
            display: "flex",
            flexDirection: "column",
            rowGap: 15,
            width: cardW * 4 + cardGap * 3,
            height: '100%',
            justifyContent: "center",
            [theme.breakpoints.down('lg')]: {
                justifyContent: "start",
                width: s_cardW * 4 + s_cardGap * 3,
            },
        },
        '.dashboard-cartoon-card': {
            backgroundColor: thirdly2,
            borderRadius: radius,
            width: cardW,
            [theme.breakpoints.down('lg')]: {
                width: s_cardW
            },
        },
        '.card': {
            border: `1px solid ${thirdly3}`,
            borderRadius: radius,
            backgroundColor: "white",
            padding: 15,
        },
        '.countries': {
            flexGrow: 1,
            height: "50%"
        },
        '.dashboard-card': {
            border: `1px solid ${thirdly3}`,
            borderRadius: radius,
            backgroundColor: "white",
            width: cardW,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            flexGrow: 1,
            padding: 15,
            [theme.breakpoints.down('md')]: {
                width: "auto",
            }
        },
        '.card-item': {
            height: "100%",
            display: "flex",
            flexDirection: "column",
            rowGap: 10,
            [theme.breakpoints.down('xxl')]: {
                rowGap: s_cardGap
            }
        },
        '.card-icon': {
            height: '30%',
            ...CenterStyle,
            ".MuiSvgIcon-root": {
                fill: "transparent !important"
            }
        },
        '.card-label': {
            flexGrow: 1,
            fontSize: 17,
            ...CenterStyle
        },
        '.card-btn': {
            height: '30%',
            ...CenterStyle
        },
        '.dashboard-video': {
            borderRadius: radius,
            width: cardW * 3 + cardGap * 2,
            [theme.breakpoints.down('lg')]: {
                width: "auto"
            },
        },
        '.card-header': {
            display: "flex",
            columnGap: cardGap,
            justifyContent: "center",
            height: cardHeaderH,
            [theme.breakpoints.down('md')]: {
                flexDirection: "column",
                height: "auto",
                rowGap: s_cardGap,
            }
        },
        '.card-content': {
            display: "flex",
            columnGap: cardGap,
            justifyContent: "center",
            // flexGrow: 1,
            height: cardHeaderH / 1.4,
            [theme.breakpoints.down('md')]: {
                flexDirection: "column",
                height: "auto",
                rowGap: s_cardGap
            }
        },
        '.dashboard-cartoon': {
            position: "relative",
            right: 15,
            width: cartoonWidth,
            height: cartoonHeight,
            [theme.breakpoints.down('md')]: {
                width: s_cartoonWidth,
                height: s_cartoonHeight,
            },
        },
        '.dashboard-title': {
            height: 80,
            padding: 30,
            width: cardW / 2,
            fontSize: 19,
            [theme.breakpoints.down('md')]: {
                height: 40,
                width: s_cardW / 2,
                padding: 15
            }
        },
    }
});

const ManagerDashboardStyles = muiStyled(Box)(({ theme, $systemUI }) => {
    const isMdDown = useMediaQuery(theme.breakpoints.down('md'));

    // const mediaQueries = breakpoints.map(bp => useMediaQuery(bp.value));
    // const bpIndex = mediaQueries.findIndex(media => media);
    // const breakpoint = breakpoints[bpIndex].upSize

    // let cardW = 245
    // let cardGap = 20
    // let cardHeaderH = 350
    // if (bpIndex != -1) {
    //     cardW = breakpoint * cardW
    //     cardGap = breakpoint * cardGap
    //     cardHeaderH = breakpoint * cardHeaderH
    // }
    let cardW = 280
    let cardGap = 20
    let cardHeaderH = 570
    let cartoonHeight = 240
    let cartoonWidth = 160

    let s_cardHeaderH = 150
    let s_cardW = "100%"
    let s_cartoonHeight = 170
    let s_cartoonWidth = 90
    let s_cardGap = 8

    return {
        display: "flex",
        justifyContent: "center",
        overflow: "hidden",
        height: "100%",
        alignItems: "center",
        '.wrap-pisabar-stats': {
            height: "40%"
        },
        '.pisabar-stats': {
            height: "100%",
            boxSizing: "border-box",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            rowGap: 10
        },
        '.dot': {
            width: 8,
            height: 8,
            borderRadius: 30
        },
        '.bar-chart-detail': {
            display: "flex",
            columnGap: 8,
            alignItems: "center"
        },
        '.chart-sub-title': {
            color: "#26445A80",
            fontWeight: 400,
            fontSize: 16
        },
        '.bar-chart-details': {
            display: "flex",
            columnGap: 10,
            width: "100%"
        },
        '.all-data-btn': {
            display: "flex",
            justifyContent: "end",
            position: "relative",
            bottom: 40
        },
        '.chart-header': {
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            width: "100%"
        },
        '.bar-chart': {
            width: "100%",
            height: 500,
            display: "flex",
            justifyContent: "center"
        },
        '.chart-title': {
            fontWeight: "bold"
        },
        '.doughnut-and-select': {
            display: "flex",
            justifyContent: "space-around",
            rowGap: 10
        },
        '.circle-stats-list': {
            display: "flex",
            columnGap: 8,
            rowGap: 20
        },
        '.line-stats-img': {
            width: "100%",
            height: 180,

        },
        '.doughnut-and-list': {
            display: "flex",
            flexDirection: "column",
            rowGap: 15
        },
        '.line-stats-title': {
            fontWeight: 600,
            padding: 3,
            fontSize: 18
        },
        '.circle-stats-img': {
            width: 180,
            height: 180,
            display: "flex",
            justifyContent: "center",
            alignItems: "center"
        },
        '.stats-list-item': {
            display: "flex",
            columnGap: 10,
            height: 35,
            alignItems: "center",
            ':hover': {
                opacity: 0.7,
                cursor: "pointer"
            }
        },
        '.stats-list-icon': {
            width: 15,
            height: 15
        },
        '.countries-img': {
            width: "100%",
            height: "100%"
        },
        '.line-stats': {
            display: "flex",
            alignItems: "center",
            flexDirection: "column",
            rowGap: 10,
            width: "50%",
            boxSizing: "border-box",
            [theme.breakpoints.down('xl')]: {
                width: "100%"
            },
        },
        '.circle-stats': {
            display: "flex",
            flexDirection: "column",
            rowGap: 5,
            width: "50%",
            boxSizing: "border-box",
            [theme.breakpoints.down('xl')]: {
                width: "100%"
            }
        },
        '.wrap-cards': {
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            rowGap: 10,
            boxSizing: "border-box"
        },
        '.stats-cards': {
            display: "flex",
            columnGap: 10,
            width: "100%",
            flexGrow: 1,
            height: "60%",
            [theme.breakpoints.down('xl')]: {
                flexDirection: "column",
                height: "auto",
                rowGap: 10
            },
        },
        [theme.breakpoints.down('md')]: {
            alignItems: "start"
        },
        '.dashboard': {
            overflow: "auto",
            boxSizing: "border-box",
            padding: 15,
            display: "flex",
            flexDirection: "column",
            rowGap: 15,
            width: cardW * 4 + cardGap * 3,
            height: '100%',
            justifyContent: "center",
            [theme.breakpoints.down('xxl')]: {
                justifyContent: "start",
                width: s_cardW * 4 + s_cardGap * 3,
            },
        },
        '.dashboard-cartoon-card': {
            backgroundColor: thirdly2,
            borderRadius: radius,
            width: cardW,
            [theme.breakpoints.down('lg')]: {
                width: s_cardW
            },
        },
        '.dashboard-card': {
            border: `1px solid ${thirdly3}`,
            borderRadius: radius,
            backgroundColor: "white",
            width: cardW,
            display: "flex",
            justifyContent: "center",
            flexDirection: "column",
            alignItems: "center",
            flexGrow: 1,
            padding: 15,
            [theme.breakpoints.down('md')]: {
                width: "auto",
            }
        },
        '.card-item': {
            height: "100%",
            display: "flex",
            rowGap: 10,
            flexDirection: "column",
            [theme.breakpoints.down('xxl')]: {
                rowGap: s_cardGap
            }
        },
        '.card-icon': {
            height: '30%',
            ...CenterStyle,
            ".MuiSvgIcon-root": {
                fill: "transparent !important"
            }
        },
        '.card-label': {
            flexGrow: 1,
            fontSize: 17,
            ...CenterStyle
        },
        '.card-btn': {
            height: '30%',
            ...CenterStyle
        },
        '.dashboard-video': {
            borderRadius: radius,
            width: cardW * 3 + cardGap * 2,
            [theme.breakpoints.down('lg')]: {
                width: "auto"
            },
        },
        '.card-header': {
            display: "flex",
            columnGap: cardGap,
            justifyContent: "center",
            height: cardHeaderH,
            [theme.breakpoints.down('xl')]: {
                height: "auto",
                rowGap: s_cardGap,
            },
            [theme.breakpoints.down('md')]: {
                flexDirection: "column",
                height: "auto",
                rowGap: s_cardGap,
                // height: 300
            }
        },
        '.card-content': {
            display: "flex",
            columnGap: cardGap,
            justifyContent: "center",
            // flexGrow: 1,
            // height: cardHeaderH / 1.8,
            [theme.breakpoints.down('md')]: {
                flexDirection: "column",
                height: "auto",
                rowGap: s_cardGap
            }
        },
        '.dashboard-cartoon': {
            position: "relative",
            right: 15,
            width: cartoonWidth,
            height: cartoonHeight,
            [theme.breakpoints.down('md')]: {
                width: s_cartoonWidth,
                height: s_cartoonHeight,
            },
        },
        '.dashboard-title': {
            height: 50,
            padding: 30,
            width: cardW / 2,
            fontSize: 19,
            [theme.breakpoints.down('md')]: {
                height: 40,
                width: s_cardW / 2,
                padding: 15
            }
        },
    }
});

const StudentDashboardStyles = muiStyled(Box)(({ theme, $systemUI, cartoonHeight, cartoonWidth }) => {
    let cardW = 300
    let cardGap = 20
    let contentH = 500

    return {
        display: "flex",
        flexDirection: "column",
        overflow: "hidden",
        height: "100%",
        width: "100%",
        rowGap: 50,
        '.logout': {
            position: "absolute",
            top: 25,
            right: 25
        },
        '.start-a-task': {
            display: "flex",
            columnGap: 10,
            fontWeight: 300
        },
        '.left-cards': {
            display: "flex",
            flexDirection: "column",
            rowGap: cardGap,
            height: "100%"
        },
        '.dashboard-content': {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexGrow: 1,
            overflowY: "auto",
            [theme.breakpoints.down('lg')]: {
                alignItems: "start"
            },
        },
        '.dashboard-cards-content': {
            alignItems: "center",
            padding: 15,
            display: "flex",
            columnGap: cardGap,
            rowGap: cardGap,
            width: cardW * 4 + cardGap * 3,
            height: contentH,
            justifyContent: "center",
            [theme.breakpoints.down('md')]: {
                height: 300
            },
        },
        '.cartoon-img': {
            position: "relative",
            right: 75,
            top: 27,
            width: 300,
            height: 300,
            [theme.breakpoints.down('md')]: {
                height: 200,
                width: 200,
            },
        },
        '.task-img': {
            position: "relative",
            left: 75,
            width: 150,
            height: 150,
            [theme.breakpoints.down('md')]: {
                height: 100,
                width: 100,
            },
        }
    }
});

const DashboardStyles = muiStyled(Box)(({ theme, $systemUI, cartoonHeight, cartoonWidth }) => {
    return {
    }
});

const DoughnutChartStyles = muiStyled(Box)(({ type, theme, $systemUI }) => ({
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "100%",
    height: "100%"
}));

const Dashboard = styled.div`
padding:15px;
display: flex;
flex-direction: column;
row-gap: 15px;
width:95%;
`

const WrapHeader = styled.div`
display: flex;
column-gap: 10px;
justify-content:space-between;
`

const WrapContent = styled.div`
display: flex;
column-gap:20px;
`

const WrapTitle = styled.div`
width:140px;
`

const Title = styled.div`
color:${black};
// font-size:20px;
font-size:0.900rem;
`

const WrapVideo = styled.div`
display: flex;
`

const WrapCartoon = styled(WrapImg)`
position: relative;
right: 112px;
`

const IOSSwitch = muiStyled((props) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: thirdly,
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: thirdly,
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E6F0FE',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#E6F0FE',
        }),
    },
}));

export { IOSSwitch, WrapCartoon, WrapVideo, Dashboard, DoughnutChartStyles, ManagerDashboardStyles, GeneralDashboardStyles, StudentDashboardStyles, DashboardStyles, WrapHeader, WrapContent, WrapTitle, Title, CardStyles }